import { Flex, SidebarDivider, formatNumber } from '@equifinance/shared';
import styled from 'styled-components';

type SidebarFooterItemType = 'none' | 'error' | 'success';

export const SidebarFooterItemContainer = styled(Flex)<{sidebarFooterItemType: SidebarFooterItemType}>` ${({ theme, sidebarFooterItemType }) => `
  justify-content: space-between;
  align-items:center;
  font-weight:${theme.fontWeight.bold};
  font-size:${theme.fontSize[1]};
  padding: ${theme.padding[1]} ${theme.padding[5]} ${theme.padding[1]} ${theme.padding[5]};
  ${sidebarFooterItemType !== 'none'
    ? `background: ${sidebarFooterItemType === 'success'
      ? theme.colours.success[2]
      : theme.colours.danger[2]} `
    : ''}
`}`;

export const SidebarFooterItemValue = styled.div` ${({ theme }) => `
  font-weight:${theme.fontWeight.normal};
`}`;

const defaultValue = '-';

export default function SidebarFooterItem({
  title,
  value,
  prefix = '',
  suffix = '',
  decimalPlaces,
  sidebarFooterItemType = 'none',
}: {
  title: string,
  value?: string | number,
  prefix?: string,
  suffix?: string,
  decimalPlaces?: number,
  sidebarFooterItemType?: SidebarFooterItemType,
}) {
  if (typeof value === 'number') {
    value = formatNumber(value, decimalPlaces);
  }

  return (
    <>
      <SidebarFooterItemContainer sidebarFooterItemType={sidebarFooterItemType}>
        <div>{title}</div>
        <SidebarFooterItemValue>
          {value ? (
            <>
              {prefix}
              {value}
              {suffix}
            </>
          ) : (
            <>{ defaultValue }</>
          )}
        </SidebarFooterItemValue>

      </SidebarFooterItemContainer>
      <SidebarDivider />
    </>
  );
}
